export default "__VITE_PUBLIC_ASSET__5cb2397a__"